import * as React from "react";
import { Slider as MaterialSlider, SliderProps, SliderThumb } from "@mui/material";
import { getDataProps, type WithDataProps } from "../../shared/utilities";

interface StyledThumbComponentProps extends React.HTMLAttributes<unknown> { }


const ThumbComponent = (props: StyledThumbComponentProps) => {
    const { children, ...other } = props;
    return (
        <SliderThumb {...other}>
            {children}
            <span className="MuiSlider-thumb-middle" />
        </SliderThumb>
    );
}

const Slider: React.FunctionComponent<WithDataProps<SliderProps>> = (props: WithDataProps<SliderProps>) => <MaterialSlider components={{ Thumb: ThumbComponent }} valueLabelDisplay="on" {...props} {...getDataProps(props)} />

export default Slider;